module.exports = ".item-error-messsage {\r\n    color: red !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/setting/common/modal-common-save.component.css
// module id = ./src/app/app_manager/modal/setting/common/modal-common-save.component.css
// module chunks = main